/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {PaydayGameAssets} from "./PaydayGameAssets";
import {PaydaySound} from "./sound/PaydaySound";
import {PaydayBackgroundElements} from "./view/PaydayBackgroundElements";
import {PaydayWinPresentation} from "./gameflow/PaydayWinPresentation";
import {PaydayBetPresentation} from "./gameflow/PaydayBetPresentation";
import {PaydayNormalResultPresentation} from "./gameflow/PaydayNormalResultPresentation";
import {PaydayIdleNormalPresentation} from "./gameflow/PaydayIdleNormalPresentation";
import {PaydayModel} from "./server/PaydayModel";
import {PaydayWinView} from "./view/PaydayWinView";
import {PaydayTransitionScreenView} from "./view/PaydayTransitionScreenView";
import {TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {RestoreUtils} from "./utils/RestoreUtils";
import {PaydayReelView} from "./reels/PaydayReelView";
import {PaydayForegroundElements} from "./view/PaydayForegroundElements";
import {
    BonusFeatureDisplayConfigurationList
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {PaydayIdleFreespinsPresentation} from "./gameflow/PaydayIdleFreespinsPresentation";
import {Speedster} from "./utils/Speedster";


export class Payday extends SlotGame {
    public static model: PaydayModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: PaydaySound;
    public static gameFlowController: GameFlowController;

    public static backgroundElements: PaydayBackgroundElements;
    public static foregroundElements: PaydayForegroundElements;
    public static reelView: PaydayReelView;
    public static winView: PaydayWinView;
    public static transitionScreen: PaydayTransitionScreenView;

    constructor() {
        super();
    }

    public static isWinBelowStake(): boolean {
        return Payday.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBetPrice());
    }

    public static getBetPrice(): number {
        const betLevel: string = Payday.apiPlugin.freeBets.hasFreeBets() ? Payday.apiPlugin.freeBets.getBet() : Payday.apiPlugin.betLevel.getLevel();
        let price: number = Payday.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (Payday.model.data.wasFeatureBuy || Payday.model.isBoostedBet()) {
            for (let index = 0; index < Payday.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Payday.model.initData.featureBuyTimesBetValue[index].name === Payday.model.buyFeatureName) {
                    price *= Payday.model.initData.featureBuyTimesBetValue[index].price;
                    price = MathHelper.roundToDecimals(price, 2);
                    break;
                }
            }
        }
        return price
    }

    private static getAccumulatedRoundWin(): number {
        return Payday.model.data.accumulatedRoundWin;
    }

    getNoWinGameData(): any {
        return {
            "playedBetValue": 1,
            "thisResponseWinnings": 0,
            "accumulatedRoundWin": 0,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "brokeTheBank": false,
            "freespinsPlayed": 0,
            "freespinsLeft": 0,
            "serverTestInfo": {},
            "reels": [
                "20",
                "50",
                "2",
                "0",
                "2",
                "0",
                "0",
                "0",
                "0"
            ],
            "successfulClaws": [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "clawPositions": [
                6
            ]
        };
    }


    public getSymbolString(key: string, data: {
        1: number,
    }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/X${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="multiplier" data-multiplier="${data[1] * 1.00}">${data[1] * 1.00}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getPaytable(): Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });


        const symbolDataValueData = Payday.model.data.symbolValues;

        return super.getPaytable().then((text:string)=>{
            const data : any = {
                godModeValue : this.getGodModeValue(),
                replaceWincapInfo: Payday.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showLowProbabilityGfx: Payday.apiPlugin.gameClientConfiguration.showLowProbabilityGfx
            }
            for (let key in symbolDataValueData) {
                text = text.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]));
            }
            return Payday.apiPlugin.translations.render(text, data);
        });
    }

    public getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#actionSpinsAllowed", "g"), (Payday.apiPlugin.gameClientConfiguration.actionSpin ? "" : "actionSpinsNotAllowed"));

            return value;
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            Payday.model = new PaydayModel(SlotGame.apiPlugin, true);
            Payday.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Payday.model);
            Payday.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            const normalIdle = new PaydayIdleNormalPresentation();
            const freespinsIdle = new PaydayIdleFreespinsPresentation();
            const normalBet = new PaydayBetPresentation();
            const normalResult = new PaydayNormalResultPresentation();
            const normalWinPres = new PaydayWinPresentation();

            Payday.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, normalIdle],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));
            Payday.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinsIdle],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(PaydayGameAssets.RESOURCES_GROUPS);
            Payday.assetLoader = new AssetLoader(Payday.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), Payday.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {

            RestoreUtils.startupGame();
            Payday.soundPlayer.switchMusic("INTRO");

            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            (<any>NolimitApplication.pixiApp.renderer.mask).enableScissor = true;

            Payday.gameFlowController.start();
            // hackjob for double or nothing restore music
            if (Payday.model.initData.nextMode == "GAMBLE_FIFTY_FIFTY") {
                Payday.soundPlayer.fadeOutMusic(1);
                Payday.soundPlayer.playLoopingSound("winCapLoop");
            } else {
                const music = Payday.model.data.nextMode == "UPGRADE_BET" ? "NORMAL" : Payday.model.data.mode;
                Payday.soundPlayer.switchMusic(music);
            }
            if (!Payday.model.isRestore && !Payday.apiPlugin.isReplay) {
                Payday.soundPlayer.playSoundBased("gameStartOneShot");
            }
            return value;
        });
    }

    private getGodModeValue(): string {
        for (let i: number = 0; i < Payday.model.initData.featureBuyTimesBetValue.length; i++) {
            if (Payday.model.initData.featureBuyTimesBetValue[i].name === "GOD_MODE") {
                return Payday.model.initData.featureBuyTimesBetValue[i].price.toString();
            }
        }

        return "";
    }

    private createViewsAndComponents() {
        //Non views
        Payday.soundPlayer = new PaydaySound();

        //Static views
        Payday.backgroundElements = new PaydayBackgroundElements();
        Payday.reelView = new PaydayReelView();
        Payday.foregroundElements = new PaydayForegroundElements();
        Payday.winView = new PaydayWinView();
        Payday.transitionScreen = new PaydayTransitionScreenView();

        NolimitApplication.addLayerAt("Speedster", new Speedster());
        NolimitApplication.addLayerAt(Payday.transitionScreen.name, Payday.transitionScreen, 0);
        NolimitApplication.addLayerAt(Payday.winView.name, Payday.winView, 0);
        NolimitApplication.addLayerAt(Payday.foregroundElements.name, Payday.foregroundElements, 0);
        NolimitApplication.addLayerAt(Payday.reelView.name, Payday.reelView, 0);
        NolimitApplication.addLayerAt(Payday.backgroundElements.name, Payday.backgroundElements, 0);
    }

    public getNolimitBonusDisplayConfiguration():BonusFeatureDisplayConfigurationList {

        return {
            GOD_MODE:{
                displayName:"GOD MODE",
                displayOrder:0,
                replacePopUpContent:(content:BonusBuyPopUpContent) => {
                    const warningTextText = Payday.apiPlugin.gameClientConfiguration.replaceWincapInfo ? "Warning: 1 Spin. No Win or 5000 times the bet!" : "Warning: 1 Spin. No Win or Max Win!";
                    const warningText = new Label(Payday.apiPlugin.translations.translate(warningTextText),
                                                  content.textLabel.getStyleClone());
                    const scale = Math.min(560 / warningText.width, 1);
                    warningText.scale.set(0.7, 0.7);
                    warningText.anchor.set(0.5, 0.5);
                    warningText.position.set(0, 400);
                    content.addChild(warningText);

                    content.textLabel.scale.set(0.8, 0.8);
                    content.textLabel.position.y -= 30;

                    const godModeStillImage = content.featureImage;
                    const godModeSpine = new PIXI.spine.Spine(Payday.assetLoader.getSpineAsset(PaydayGameAssets.GOD_MODE_POPUP))
                    godModeSpine.state.setAnimation(0, "Loop", true);
                    godModeSpine.position.copyFrom(godModeStillImage);
                    godModeSpine.position.y += 100;

                    content.featureImage = <PIXI.Sprite>(<any>godModeSpine);
                    content.removeChild(godModeStillImage);
                    content.addChild(godModeSpine);


                    return content;
                }
            },
            BOOSTED_BET:{
                displayName:"xBet",
                displayOrder:0,
            },
        }
    }
}